import React from 'react';

import { useHistory } from 'react-router-dom';
import { SideSpacer } from '../../components/common/Spacer';
import HeaderContainer from '../../containers/common/HeaderContainer';
import Navigation from '../../components/common/Navigation';
import {
  CommonContainer,
  HistoryBlock,
  NormalHistory,
  HistoryBtn
} from '../../components/common/Container';
import { RiArrowLeftSLine } from 'react-icons/ri';
import KioskSettingContainer from '../../containers/app/KioskSettingContainer';

const KioskProductSettingPage = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  let history = useHistory();

  const onClickBackButton = () => {
    history.goBack()
  }

  if (!user) {
    alert('잘못된 접근입니다 다시 로그인 해 주세요');
    history.push('/');
    return false;
  }

  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
        <CommonContainer style={{minWidth: '1450px'}}>
            <HistoryBlock>
              <HistoryBtn style={{marginBottom: '15px'}}><RiArrowLeftSLine onClick={() => onClickBackButton()}/></HistoryBtn>
              <NormalHistory style={{fontWeight: 'bold', marginBottom: '15px'}} >
                키오스크 설정
              </NormalHistory>
            </HistoryBlock>
            <KioskSettingContainer history={history}/>
        </CommonContainer>
      </SideSpacer>
    </>
  );
};

export default KioskProductSettingPage;

